import React, { useEffect, useMemo, useState } from "react";
import { api, formatMinutes } from "../lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export default function Planejamento() {
  const [sessions, setSessions] = useState([]);
  const [cursor, setCursor] = useState(new Date());

  useEffect(() => {
    api.get("/study-sessions").then((r) => setSessions(r.data));
  }, []);

  const y = cursor.getFullYear();
  const m = cursor.getMonth();
  const first = new Date(y, m, 1);
  const startDay = first.getDay();
  const daysInMonth = new Date(y, m + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(y, m, d));

  const byDate = useMemo(() => {
    const map = {};
    sessions.forEach((s) => {
      if (!map[s.date]) map[s.date] = [];
      map[s.date].push(s);
    });
    return map;
  }, [sessions]);

  const monthLabel = cursor.toLocaleDateString("pt-BR", { month: "long", year: "numeric" });

  return (
    <div className="space-y-6 max-w-[1400px]">
      <h1 className="font-display text-3xl font-extrabold">Planejamento</h1>

      <div className="rounded-2xl bg-card border border-border p-5">
        <div className="flex items-center justify-between mb-4">
          <button onClick={() => setCursor(new Date(y, m - 1, 1))} className="p-2 rounded hover:bg-muted"><ChevronLeft size={18} /></button>
          <h2 className="font-display font-bold text-lg capitalize">{monthLabel}</h2>
          <button onClick={() => setCursor(new Date(y, m + 1, 1))} className="p-2 rounded hover:bg-muted"><ChevronRight size={18} /></button>
        </div>

        <div className="grid grid-cols-7 gap-2 text-center text-sm font-semibold text-muted-foreground mb-2">
          {DAYS.map((d) => <div key={d}>{d}</div>)}
        </div>

        <div className="grid grid-cols-7 gap-2">
          {cells.map((d, i) => {
            if (!d) return <div key={i} />;
            const iso = d.toISOString().split("T")[0];
            const items = byDate[iso] || [];
            const totalMin = items.reduce((a, b) => a + (b.duration_minutes || 0), 0);
            const isToday = iso === new Date().toISOString().split("T")[0];
            return (
              <div key={i} className={`min-h-[80px] rounded-lg border p-2 text-xs ${isToday ? "border-tiffany-500 bg-tiffany-50 dark:bg-tiffany-900/20" : "border-border bg-muted/30"}`}>
                <div className={`font-bold mb-1 ${isToday ? "text-tiffany-600" : ""}`}>{d.getDate()}</div>
                {items.slice(0, 2).map((it, j) => (
                  <div key={j} className="truncate rounded bg-tiffany-500 text-white px-1.5 py-0.5 mb-0.5" title={it.discipline_name}>
                    {it.discipline_name}
                  </div>
                ))}
                {items.length > 2 && <div className="text-tiffany-600 font-semibold">+{items.length - 2}</div>}
                {totalMin > 0 && <div className="text-muted-foreground mt-1">{formatMinutes(totalMin)}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
